import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Lock, Download } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="py-20 px-4 bg-[#FFF8E7] relative overflow-hidden" data-id="element-76">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-[#D4A017]/30" data-id="element-78">
          <div className="bg-[#D4A017] p-4 text-center" data-id="element-79">
            <h2 className="text-2xl font-bold text-white" data-id="element-80">
              Oferta Especial por Tiempo Limitado
            </h2>
          </div>

          <div className="p-8 md:p-12 flex flex-col items-center text-center" data-id="element-81">
            <h3 className="text-3xl md:text-4xl font-bold text-[#5C3D2E] mb-4" data-id="element-82">
              Cenas en 1 Olla: El Método Anti-Inflamatorio
            </h3>
            <p className="text-xl text-[#5C3D2E] mb-8 max-w-2xl" data-id="element-83">
              Recibe acceso inmediato a la guía digital (PDF), el recetario
              maestro, la lista de compras y el tablero de control.
            </p>

            <div className="flex items-end justify-center gap-2 mb-8" data-id="element-84">
              <span className="text-2xl text-[#5C3D2E] line-through opacity-50" data-id="element-85">
                $39.99
              </span>
              <span className="text-6xl font-black text-[#C67B5C] leading-none" data-id="element-86">
                $9.99
              </span>
              <span className="text-xl text-[#5C3D2E] font-medium mb-1" data-id="element-87">
                USD
              </span>
            </div>

            <p className="text-lg font-medium text-[#5B7A3A] mb-8 bg-[#5B7A3A]/10 px-6 py-2 rounded-full" data-id="element-88">
              Menos de lo que cuesta un almuerzo fuera de casa.
            </p>

            <Button size="xl" className="w-full md:w-auto px-12 mb-6 shadow-xl shadow-[#D4A017]/30 animate-pulse-slow" onClick={() => window.open('https://vidaensazon.com/cart/53134994899258:1', '_blank')} data-id="element-89">
              <Download className="w-6 h-6 mr-2" data-id="element-90" />
              Descargar Mi Guía Ahora
            </Button>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-[#5C3D2E] opacity-80 mt-4" data-id="element-91">
              <div className="flex items-center gap-2" data-id="element-92">
                <Lock className="w-5 h-5" data-id="element-93" />
                <span data-id="element-94">Pago 100% Seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-95">
                <ShieldCheck className="w-5 h-5 text-[#5B7A3A]" data-id="element-96" />
                <span data-id="element-97">Garantía de 7 días</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}